export enum ReportContentTypeEnum {
  CSV = 'csv',
  PDF = 'pdf'
}
